import React from "react";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import SeasonalTransferTable from "@components/table/zenith/SeasonalTransferTable";
import SeasonalAssignmentModal from "@components/modal/SeasonalAssignmentModal";
import { useApprovalTabsContext } from "@components/layout/zenith/ApprovalTabs";
import { useAdministrativeApproval } from "@hooks/query/zenith/useAdministrativeApproval";

const SeasonalTransferIndex = () => {
  const { t } = useTranslation();
  const { setBreadcrumbs } = useApprovalTabsContext();
  const [searchParams, setSearchParams] = useSearchParams();
  const approvalId = searchParams.get("id") ?? "";
  const { data } = useAdministrativeApproval(approvalId);

  React.useEffect(() => {
    setBreadcrumbs([
      {
        label: t("approval.seasonal_water_assignments.title"),
      },
    ]);
  }, [t, setBreadcrumbs]);

  const handleClose = () => {
    searchParams.delete("id");
    setSearchParams();
  };

  return (
    <>
      <SeasonalTransferTable />
      {approvalId && data ? (
        <SeasonalAssignmentModal
          data={data}
          onClose={handleClose}
          actionButtons={
            <button className="btn-default" onClick={handleClose}>
              {t("common.close")}
            </button>
          }
        />
      ) : null}
    </>
  );
};

export default SeasonalTransferIndex;
